import { render, staticRenderFns } from "./debug.vue?vue&type=template&id=2512909f&"
import script from "./debug.vue?vue&type=script&lang=js&"
export * from "./debug.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VApp,VMain,VToolbar})
